import {
  ChatbotState,
  ChatbotActionTypes,
  SetChatbotStatusAction,
  SetChatbotTriggerTypeAction,
  SetProactiveModalViewedPageAction,
  SetGigaEventTriggeredPageAction,
  IncrementVasCounterAction,
  IncrementProductCounterAction,
  MarkVasTriggeredPageAction,
  MarkProductTriggeredPageAction,
} from '~/types/chatbot';

export const setChatbotStatus = (status: ChatbotState['status']): SetChatbotStatusAction => ({
  type: ChatbotActionTypes.SET_CHATBOT_STATUS,
  status,
});

export const setChatbotTriggerType = (triggerType: ChatbotState['triggerType']): SetChatbotTriggerTypeAction => ({
  type: ChatbotActionTypes.SET_CHATBOT_TRIGGER_TYPE,
  triggerType,
});

export const setProactiveModalViewedPage = (page: string, viewed: boolean): SetProactiveModalViewedPageAction => ({
  type: ChatbotActionTypes.SET_PROACTIVE_MODAL_VIEWED_PAGE,
  page,
  viewed,
});

export const setGigaEventTriggeredPage = (page: string, viewed: boolean): SetGigaEventTriggeredPageAction => ({
  type: ChatbotActionTypes.SET_GIGA_EVENT_TRIGGERED_PAGE,
  page,
  viewed,
});

export const incrementVasCounter = (): IncrementVasCounterAction => ({
  type: ChatbotActionTypes.INCREMENT_VAS_COUNTER,
});

export const incrementProductCounter = (): IncrementProductCounterAction => ({
  type: ChatbotActionTypes.INCREMENT_PRODUCT_COUNTER,
});

export const markVasTriggeredPage = (page: string): MarkVasTriggeredPageAction => ({
  type: ChatbotActionTypes.MARK_VAS_TRIGGERED_PAGE,
  page,
});

export const markProductTriggeredPage = (page: string): MarkProductTriggeredPageAction => ({
  type: ChatbotActionTypes.MARK_PRODUCT_TRIGGERED_PAGE,
  page,
});
